import LabServiceCollection from "@/collections/LabServiceCollection";
import ScheduleStatusLogModel from "@/models/lab/ScheduleStatusLogModel";

export default class ScheduleStatusLogCollection extends LabServiceCollection {
  model() {
    return ScheduleStatusLogModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddDesc('created_at');
    
    return CollectionFilter;
  }

}
